import { Translation } from "@/data/lang";
import { links } from "@/data/links";
import { Lang } from "@/i18n-config";

import { NavigationLink, getAiViewLinks } from "./navigation-links";

type NavigationSection = {
  key:
    | "overview"
    | "ai-analysis"
    | "financial-report"
    | "share-holding"
    | "tradingview-chart";
  title: string;
  pageLink: string;
  subLinks: NavigationLink[];
};

// This commit remove the link to section of navigation, you can refer it if we need to add it back.

export const getNavigationList = ({
  lang,
  t,
  symbol,
}: {
  lang: Lang;
  t: Translation;
  symbol: string;
}): NavigationSection[] => [
  {
    key: "overview",
    title: t.analysis.navigation.layoutNavOverview,
    pageLink: `/${lang}${links.myAnalysisOverview({ symbol })}`,
    subLinks: [],
  },
  {
    key: "ai-analysis",
    title: t.analysis.navigation.layoutNavAiView,
    pageLink: "",
    subLinks: getAiViewLinks({ t, symbol, lang }),
  },
  {
    key: "financial-report",
    title: t.analysis.navigation.layoutNavFinancialMetrics,
    pageLink: `/${lang}${links.myAnalysisFinancialReport({ symbol })}`,
    subLinks: [],
  },
  {
    key: "share-holding",
    title: t.analysis.navigation.layoutNavWhaleInterest,
    pageLink: `/${lang}${links.myAnalysisWhaleInterestShareHolding({
      symbol,
    })}`,
    subLinks: [],
  },
  {
    key: "tradingview-chart",
    title: t.analysis.navigation.layoutNavTradingView,
    pageLink: `/${lang}${links.myAnalysisTradingViewAdvancedChart({
      symbol,
    })}`,
    subLinks: [],
  },
];
